import OutlinedText from './OutlinedText';

export default OutlinedText;
